import { AccordionSection } from '../components/accordion-section/AccordionSection';
import { Button } from '../components/button/Button';
import { ColumnsSection } from '../components/columns-section/ColumnsSection';
import { ComparisonColumn } from '../components/comparison-table/ComparisonColumn';
import { ComparisonTable } from '../components/comparison-table/ComparisonTable';
import { ContentSection } from '../components/content-section/ContentSection';
import { Footer } from '../components/footer/Footer';
import { Header } from '../components/header/Header';
import { ImageMarquee } from '../components/image-marque/ImageMarquee';
import { InlineTextSection } from '../components/inline-text-section/InlineTextSection';
import { Item } from '../components/item/Item';
import { PageLivePreview } from '../components/page/PageLivePreview';
import { PdfSection } from '../components/pdf-section/PdfSection';
import { ProductGridSection } from '../components/product-grid-section/ProductGridSection';
import { Testimonials } from '../components/testimonials/Testimonials';
import { TextBlock } from '../components/text-block/TextBlock';
import { TextMarquee } from '../components/text-marquee/TextMarquee';
import { UniqueComponent } from '../components/unique-component/unique-component';
import { BasicLivePreview } from '../live-preview/BasicLivePreview';
import { BlockMap } from './types';

export const livePreviewBlockMap: BlockMap = {
	accordion: BasicLivePreview(AccordionSection),
	button: BasicLivePreview(Button),
	columnsSection: BasicLivePreview(ColumnsSection),
	comparisonColumn: BasicLivePreview(ComparisonColumn),
	comparisonTable: BasicLivePreview(ComparisonTable),
	contentSection: BasicLivePreview(ContentSection),
	footer: BasicLivePreview(Footer),
	header: BasicLivePreview(Header),
	imageMarque: BasicLivePreview(ImageMarquee), // TODO(amatlash): fix typo in contentful content type.
	inlineTextSection: BasicLivePreview(InlineTextSection),
	item: BasicLivePreview(Item),
	page: PageLivePreview,
	pdfSection: BasicLivePreview(PdfSection),
	productGridSection: BasicLivePreview(ProductGridSection),
	testimonials: BasicLivePreview(Testimonials),
	textBlock: BasicLivePreview(TextBlock),
	textMarquee: BasicLivePreview(TextMarquee),
	uniqueComponent: BasicLivePreview(UniqueComponent),
} as const;
